import { render } from "./HomepageAboutUs.vue?vue&type=template&id=6304d5be&scoped=true"
const script = {}

import "./HomepageAboutUs.vue?vue&type=style&index=0&id=6304d5be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6304d5be"]])

export default __exports__